"use strict";
// Oauthに入ってくるstateパラメータの値
// ユーザー登録導線の検知に使っている
// @see https://developers.google.com/identity/protocols/oauth2/web-server
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseOauthState = void 0;
const lodash_1 = require("lodash");
const parseOauthState = (state) => {
    if ((0, lodash_1.isUndefined)(state)) {
        return undefined;
    }
    return JSON.parse(state);
};
exports.parseOauthState = parseOauthState;
//# sourceMappingURL=oauthState.js.map